/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Typography } from '@telus-uds/components-web';
import { useTranslationsContext } from '../../context/TranslationsContext';
import { getLocalFormattedTime } from '../../dashboards/salesRepDashboard/utils';
import { getDeviceName } from './utils';
import { fieldSubscriberDetailsDevicePlan } from '../../utils/constant';

const SubscribersList = ({
  subscriberDetails,
  updateOrder,
  setEditingSubscriber,
  editingSubscriber,
  currentSubscriber,
  totalSubscribers,
  setShowErrorSubscriber
}) => {
  const {
    WLS: {
      SUBSCRIBERS_LIST: {
        subscribersList,
        Name,
        Device,
        RatePlan,
        CreationDate,
        Actions,
        Edit,
        Delete
      },
      SUBSCRIBER_DETAILS: { Accessories }
    }
  } = useTranslationsContext();
  const deleteSubscriber = id => {
    const updatedSubscriberDetails = subscriberDetails.filter(
      subscriberDetail => subscriberDetail.id !== id
    );
    updateOrder({ subscriberDetails: updatedSubscriberDetails }, 'REMOVE');
  };
  return (
    <div style={{ marginTop: '3rem', marginBottom: '4.5rem' }}>
      <div
        style={{
          padding: '0.75rem',
          background: '#4b286d',
          color: '#fff',
          fontWeight: '700'
        }}
      >
        {subscribersList}
      </div>
      <table className="table table-bordered">
        <thead style={{ background: '#efefef' }}>
          <tr>
            <th scope="col"><Typography>#</Typography></th>
            <th scope="col"><Typography>{Name}</Typography></th>
            <th scope="col"><Typography>{Device}</Typography></th>
            <th scope="col"><Typography>{RatePlan}</Typography></th>
            <th scope="col"><Typography>{CreationDate}</Typography></th>
            <th scope="col"><Typography>{Actions}</Typography></th>
          </tr>
        </thead>
        <tbody>
          {subscriberDetails.map((subscriberDetail, index) => {
            const isAccessoriesOnly =
              subscriberDetail[fieldSubscriberDetailsDevicePlan] ===
              Accessories;
            const valueContractTerm = _.get(
              subscriberDetail,
              'subscriberDetailsContractTerm',
              ''
            );
            const getDeviceModel = _.get(
              subscriberDetail,
              'subscriberDetailsDeviceModel',
              ''
            );
            const subscriberId = _.get(subscriberDetail, 'id', '');
            const subscriberName = `${_.get(
              subscriberDetail,
              'subscriberDetailsFirstName',
              ''
            )} ${_.get(subscriberDetail, 'subscriberDetailsLastName', '')}`;
            const subscriberDevice = getDeviceName(
              _.get(subscriberDetail, 'subscriberDetailsDevices', '')
            );
            const subscriberRatePlan = _.get(
              subscriberDetail,
              'subscriberDetailsRateplanName',
              ''
            );
            const subscriberCreatedAt = _.get(
              subscriberDetail,
              'createdAt',
              ''
            );
            if (
              !editingSubscriber ||
              (editingSubscriber && editingSubscriber !== subscriberId)
            )
              return (
                <tr>
                  <th scope="row"><Typography>{index + 1}</Typography></th>
                  <td><Typography>{subscriberName}</Typography></td>
                  {isAccessoriesOnly ? (
                    <td><Typography>{Accessories}</Typography></td>
                  ) : valueContractTerm === '3 Year' ||
                    valueContractTerm === '3 Ans' ? (
                    <td><Typography>{getDeviceModel}</Typography></td>
                  ) : (
                    <td><Typography>{subscriberDevice}</Typography></td>
                  )}
                  <td><Typography>{subscriberRatePlan}</Typography></td>
                  <td><Typography>{getLocalFormattedTime(subscriberCreatedAt)}</Typography></td>
                  {!editingSubscriber && (
                    <td>
                      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
                        <Button
                          variant={{ priority: 'low' }}
                          onClick={() => {
                            setEditingSubscriber(subscriberId);
                            setShowErrorSubscriber(false);
                          }}
                        >
                          {Edit}
                        </Button>
                        <Button
                          variant={{ priority: 'low' }}
                          onClick={() => deleteSubscriber(subscriberId)}
                        >
                          {Delete}
                        </Button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            return null;
          })}
        </tbody>
      </table>
    </div>
  );
};

SubscribersList.propTypes = {
  subscriberDetails: PropTypes.arrayOf(PropTypes.any).isRequired,
  updateOrder: PropTypes.func.isRequired,
  setEditingSubscriber: PropTypes.func.isRequired,
  editingSubscriber: PropTypes.string.isRequired,
  currentSubscriber: PropTypes.number.isRequired,
  totalSubscribers: PropTypes.number.isRequired,
  setShowErrorSubscriber: PropTypes.func.isRequired
};

export default SubscribersList;
